// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contentDropDown {
  /*max-height: 800px;*/
  overflow: hidden;
  transition: max-height ease 0.5s;
  margin-left: 1rem;
}

.dropDownExperience {
  color: #0b4c95;
  font-weight: 600;
  cursor: pointer;
  margin: 0 auto;
  transition: 0.4s;
}

.drop-down-item-each {
  color: #0b4c95;
  font-weight: 600;
  transition: 0.4s;
  margin-top: 0.2rem;
}

.drop-down-item-each:hover,
.drop-down-item-each-active:hover,
.dropDownExperience:hover,
.dropDownExperience-active:hover {
  text-decoration: underline;
  text-decoration-color: lightblue;
  cursor: pointer;
}

.dropDownExperience-active {
  color: orange;
  font-weight: 600;
  transition: 0.4s;
  margin-top: 0.2rem;
}

.drop-down-item-each-active {
  color: orange;
  font-weight: 600;
  transition: 0.4s;
  margin-top: 0.2rem;
}
`, "",{"version":3,"sources":["webpack://./src/Products/DropDown/DropDown.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,gCAAgC;EAChC,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;;;;EAIE,0BAA0B;EAC1B,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB","sourcesContent":[".contentDropDown {\n  /*max-height: 800px;*/\n  overflow: hidden;\n  transition: max-height ease 0.5s;\n  margin-left: 1rem;\n}\n\n.dropDownExperience {\n  color: #0b4c95;\n  font-weight: 600;\n  cursor: pointer;\n  margin: 0 auto;\n  transition: 0.4s;\n}\n\n.drop-down-item-each {\n  color: #0b4c95;\n  font-weight: 600;\n  transition: 0.4s;\n  margin-top: 0.2rem;\n}\n\n.drop-down-item-each:hover,\n.drop-down-item-each-active:hover,\n.dropDownExperience:hover,\n.dropDownExperience-active:hover {\n  text-decoration: underline;\n  text-decoration-color: lightblue;\n  cursor: pointer;\n}\n\n.dropDownExperience-active {\n  color: orange;\n  font-weight: 600;\n  transition: 0.4s;\n  margin-top: 0.2rem;\n}\n\n.drop-down-item-each-active {\n  color: orange;\n  font-weight: 600;\n  transition: 0.4s;\n  margin-top: 0.2rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
